import * as React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Switch, {SwitchProps} from '@material-ui/core/Switch';
import {FormField, ExtendedWrappedFieldProps} from '../FormFields';
import {FormControlLabelProps} from '@material-ui/core/FormControlLabel/FormControlLabel';
import withStyles, {WithStyles} from '@material-ui/core/styles/withStyles';

export interface FormSwitchProps extends ExtendedWrappedFieldProps, SwitchProps {
  labelPlacement?: FormControlLabelProps['labelPlacement'];
}

const styles = theme => {
  return {
    explanation: {
      marginTop: theme.spacing(0.5),
      marginBottom: 0,
    },
  };
};

const FormSwitch = withStyles(styles)((({
  showErrors,
  meta,
  explanationText,
  instructionText,
  explanationTooltip,
  instructionPosition,
  label,
  labelPlacement,
  input,
  classes: {explanation},
  color,
  disabledTooltip,
  ...props
}) => {
  // TODO make this behavior generic to form fields
  const handleChange = (event, checked) => {
    if (props.onChange) {
      props.onChange(event, checked);
    } else {
      input.onChange(checked);
    }
  };

  return (
    <FormField
      showErrors={showErrors}
      touched={meta && meta.touched}
      error={meta && meta.error}
      explanationText={explanationText}
      instructionText={instructionText}
      explanationTooltip={explanationTooltip}
      instructionPosition={instructionPosition}
      fieldName={input ? input.name : undefined}
      formHelperText={null}
      classes={{explanation}}
      disabledTooltip={props.disabled ? disabledTooltip : undefined}
    >
      <FormControl>
        <FormControlLabel
          control={
            <Switch
              {...props}
              {...(props.onChange ? {} : input)}
              onChange={handleChange}
              color={color ? color : 'primary'}
            />
          }
          label={label}
          labelPlacement={labelPlacement}
        />
      </FormControl>
    </FormField>
  );
}) as React.FunctionComponent<FormSwitchProps & WithStyles<typeof styles>>);

export default FormSwitch;
